
import Framework from '@yld/framework'
import YunIcon from '@yld/yun-icon'
import VueClipboard from 'vue-clipboard2'

import Vue from 'vue'
const serverConfig = require('../serverConfig.json')

Vue.prototype.$eventBus = new Vue()

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

const app = new Framework({
  serverConfig
})

app.use(YunIcon)
app.start()
